import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import styles from "../askTheTeamModal/AskTheTeamStyles.module.css";
import "../AdvanceFilters/AFModalsStyles.css";
// import "./GenerativeResponseStyles.css";
import QuestionBox from "../../QuestionBox/NewQuestionBox";

export default function GenerativeResponse() {
  const dispatch = useDispatch();
  const { advanceFilterModalToggle, getRefferedSuggestions} = bindActionCreators(
    Actions,
    dispatch
  );
  const searchState = useSelector((state) => state.search);
  const modalState = useSelector((state) => state.domain);
  return (
    <>
      <Modal
        show={modalState.modalState}
        onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
        size={"lg"}
        centered={true}
      >
        <Modal.Header
          className={`${styles.modalHeaderBackground} modalHeaders`}
          closeButton
          closeVariant="white"
        >
          <Modal.Title className={styles.modalTitle}>
          <i class="fa fa-superpowers" aria-hidden="true"></i>
          &nbsp;&nbsp;
            Referred Suggestions
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-md-12 col-lg-12" style={{height:'20rem',overflow:'auto'}}>
          {searchState.refferedSuggestions.map((obj) => {
            return <QuestionBox key={obj.questionUuid} data={obj} />;
          })
        }
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
